import { useId } from 'react';
import styled from 'styled-components';

const TextInput = ({ label, ...props }) => {
  const id = useId();

  return (
    <S.Container>
      <S.Label htmlFor={id}>{label}</S.Label>
      <S.Input id={id} {...props} />
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    display: block;
    width: 100%;
  `,
  Label: styled.label`
    display: block;
    width: 100%;
    padding: 0 1rem 1rem 0;
    font-size: 1.2rem;
    letter-spacing: 1px;
    opacity: 0.6;
  `,
  Input: styled.input`
    display: block;
    width: 100%;
    border: 0.6px solid #d5d5d5;
    background: #f5f6fa;
    color: #838383;
    padding: 1.25rem 1.25rem;
    border-radius: 4px;
    font-size: 1rem;
    line-height: 1.35;
    font-weight: 200;
    letter-spacing: 1px;
    margin: 0 0.5rem 0.5rem 0;

    &:hover,
    &:focus {
      outline-color: ${({ theme }) => theme.colors.primary};
    }

    &::placeholder {
      opacity: 0.6;
    }
  `,
};

export default TextInput;
